function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_2",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 336.02 53.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_1-2",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,34.49C0,24.05,8.57,15.34,19.8,15.48c7.2.07,13.83,3.31,17.14,10.73l-10.73,5.76c-1.15-2.45-3.46-4.32-6.41-4.32-4.1,0-6.84,3.02-6.84,6.84s2.74,6.91,6.84,6.91c2.95,0,5.26-1.87,6.41-4.32l10.73,5.76c-3.31,7.42-9.94,10.66-17.14,10.73-11.23.14-19.8-8.64-19.8-19.08Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.54,34.49c0-10.44,8.57-19.08,19.8-19.08s19.8,8.64,19.8,19.08-8.57,19.15-19.8,19.15-19.8-8.64-19.8-19.15ZM67.18,34.56c0-3.82-2.74-6.98-6.84-6.98s-6.84,3.17-6.84,6.98,2.74,6.91,6.84,6.91,6.84-3.17,6.84-6.91Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.86,36.44v16.13h-12.96v-17.71c0-10.58,6.19-19.37,19.51-19.37s19.51,8.78,19.51,19.37v17.71h-12.96v-16.13c0-4.54-1.8-8.35-6.55-8.35s-6.55,3.82-6.55,8.35Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.68,34.13c0-10.37,7.78-19.01,19.15-19.01s18.36,8.78,18.36,18.43v3.24h-25.06c.86,3.6,3.6,5.76,7.56,5.76,3.46,0,6.19-1.87,7.49-4.68l9.94,4.97c-3.1,6.7-9.22,10.73-17.28,10.73-11.52,0-20.16-7.63-20.16-19.44ZM155.3,30.1c-.58-2.02-2.59-3.89-5.62-3.89s-5.18,1.8-5.98,3.89h11.59Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.11,52.56V0h12.96v29.74h2.52c.29-.58.58-1.15,1.01-1.66l8.57-11.52h15.34l-13.9,17.86,13.83,18.15h-15.19l-8.64-11.88c-.36-.5-.72-1.08-.94-1.58h-2.59v13.47h-12.96Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.65,32.69v-16.13h12.96v17.71c0,10.58-6.19,19.37-18.94,19.37s-18.94-8.78-18.94-19.37v-17.71h12.96v16.13c0,4.54,1.8,8.35,5.98,8.35s5.98-3.82,5.98-8.35Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.33,37.23v-9.86h-6.12v-10.8h6.12V7.56h12.96v9h11.81v10.8h-11.81v9.43c0,3.46,2.09,5.4,5.47,5.4,1.8,0,4.61-.5,6.34-1.44v11.45c-1.8,1.01-5.11,1.51-7.56,1.51-11.74,0-17.21-6.91-17.21-16.49Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.42,34.49c0-10.44,8.57-19.08,19.8-19.08s19.8,8.06,19.8,19.08v18.07h-12.24v-2.66c-2.3,2.38-5.54,3.74-9.72,3.74-10.51,0-17.64-8.64-17.64-19.15ZM323.06,34.56c0-3.82-2.74-6.98-6.84-6.98s-6.84,3.17-6.84,6.98,2.74,6.91,6.84,6.91,6.84-3.17,6.84-6.91Z",
    style: {
      strokeWidth: 0
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1d89286d86cd52f3e4bcbcd929f2e169.svg";
export { ForwardRef as ReactComponent };